export const SE_INBOX_NAV_TREE = {
  label: 'SeInbox', secondaryItems: [
    {
      label: 'SeInbox',
      key: 'se-inbox',
      attributes: { href: '/docs/se-inbox/overview' }
    },
    {
      label: 'Inbox',
      key: 'inbox',
      attributes: { href: '/docs/se-inbox/inbox' }
    },
    {
      label: 'Inbox Message Item',
      key: 'inbox-message-item',
      attributes: { href: '/docs/se-inbox/inbox-message-item' }
    },
    {
      label: 'Legacy Message Modal',
      key: 'legacy-message-modal',
      attributes: { href: '/docs/se-inbox/legacy-message-modal' }
    },
    {
      label: 'Message Dropdown',
      key: 'message-dropdown',
      attributes: { href: '/docs/se-inbox/message-dropdown' }
    },
    {
      label: 'Dropdown Message Item',
      key: 'dropdown-message-item',
      attributes: { href: '/docs/se-inbox/dropdown-message-item' }
    },
    {
      label: 'Message Side Panel',
      key: 'message-side-panel',
      attributes: { href: '/docs/se-inbox/message-side-panel' }
    }
  ]
}
